<nav class="navbar bg-body-tertiary">
    <div class="container-fluid">
        <a routerLink="/" class="volver-inicio" (click)="irAHome()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8.354 1.646a.5.5 0 0 0-.708 0l-6 6a.5.5 0 0 0 .708.708L8 2.707l5.646 5.647a.5.5 0 0 0 .708-.708l-6-6z"/>
              <path d="M2.5 7.5v6a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-1 0v6H3v-6a.5.5 0 0 0-1 0z"/>
            </svg>
            Volver a la página principal
          </a>
    </div>
</nav>